// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import cn from 'classnames';
import {Link, useHistory} from 'react-router-dom';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {statuses} from '../../../../hola/pub/data_ctx';
import etask from 'zetask';
// @ts-ignore
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {get_article_date, i_arts} from '../../../../hola/pub/ui/blog/i_blog';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {perr_www_visit} from 'hola_pub_util';
import {use_fetch_posts} from '../../../../hola/pub/ui/blog/use_fetch_posts';
import {Spacer} from '../../../../hola/pub/ui/homepage/spacer';
import {Article_card} from '../../ui/blog/article_card';
import {use_scrollbox} from '../../../../hola/pub/ui/use_scrollbox';
import {Paging} from '../../ui/blog/paging';
import {Loader} from '../../ui/media/loader';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {Root as Article} from './blog/article';
import {www_hola} from 'hola_opt';
import Icon_chevron_left from '../../../../hola/pub/img/hola2023/icons/24/chevron_left.svg';
import Icon_chevron_right from '../../../../hola/pub/img/hola2023/icons/24/chevron_right.svg';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import styles from './blog/blog.module.less';

const root_path = '/blog';

const get_data_id = params=>`/blog/page/${params.page}/category/`+
    `${params.category}/per_page/${params.per_page||9}/slug/${params.slug}`;

const First_article = props=>{
    const {slug} = props;
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const art_link = `/blog/${props.categories[0].slug}/${slug}`;
    return <div className={cn(theme.container, styles.latest_news_container)}>
      <div className={styles.latest_news} onClick={()=>{
        history.push(art_link);
      }} key={props.id}>
        <div className={cn(styles.latest_news_img, 'lazyload')}
          data-bg={props.preview_image || props.img || undefined}
          style={props.preview_bg ? {backgroundColor: props.preview_bg} : {}}>
        </div>
        <div className={styles.latest_news_content}>
          <div className={cn(styles.news_date, theme.u2)}>
            {get_article_date(props)}</div>
          <div className={styles.latest_news_text}>
            <h3 className={cn(theme.reg, theme.H5)}
              dangerouslySetInnerHTML={{__html: props.title}}></h3>
            <p className={cn(theme.p2, styles.read_more)}>
              <Link to={art_link}
                key={slug} className={cn(theme.reg, theme.primary)}
                aria-label={`Open article: ${props.title}`}>Read more</Link>
            </p>
          </div>
        </div>
      </div>
    </div>;
};

const Blog_root = ()=>{
    const {theme} = useContext(Settings_context);
    const root_url = root_path;
    const {data} = use_data_provider(get_data_id);
    const {params} = use_pathname();
    const {qs} = use_qs_with_set();
    const [data_state, set_data_state] = useState(data.result as i_arts);
    const root_ref = useRef<HTMLDivElement>();
    const categories_ref = useRef<HTMLDivElement>();
    const posts_url = `https://toolip.io/cms_api/blog/posts`;
    const {width} = use_screen();
    const scroll_to_top = ()=>{
        const top = root_ref.current.offsetTop - 100;
        window.scroll({left: 0, top, behavior: 'smooth'});
    };
    const on_load_more = page=>{
        set_data_state(st=>({data: {
            ...st.data,
            posts: page.posts,
        }}));
    };
    const {is_loading, abort} = use_fetch_posts({container: root_ref.current,
        posts_url, on_load_more, category: params.category,
        paged: params.page, per_page: {all: 6, xl: 9, xs: 5}});
    useEffect(()=>{
        if (data.status==statuses.done)
        {
            abort();
            set_data_state(data.result as i_arts);
        }
    }, [data]);
    useEffect(()=>{ perr_www_visit({id: 'www_blog_visit'}); }, []);
    const arrows_scroll = qs.debug_ui || www_hola.blog_arrows_scroll;
    const {is_dragging, scroll_pos, scroll} = use_scrollbox(categories_ref,
        !arrows_scroll);
    const safe_data_state = Array.isArray(data_state)
        ? data_state[0] : data_state;
    const fa = safe_data_state?.data?.posts[0];
    const show_fa = fa && (!params.page || params.page =='1');
    const root_cls = cn(theme.root, styles.root, {
        [styles.with_arrows]: arrows_scroll,
    });
    return <div className={cn(theme.root, root_cls)}>
      <p className={cn(styles.title, theme.H2)}>
        Stay up-to-date with all the latest
        news</p>
      {show_fa && <First_article {...fa}/>}
      {safe_data_state && safe_data_state.data && <div
        className={styles.categories_container}>
        <div className={cn(theme.container, styles.categories)}>
          <h3 className={cn(theme.primary, styles.categories_title, theme.H5)}>
            Browse by category</h3>
          <div className={styles.categories_box}>
            <div className={styles.scroll_btns}>
              <button
                className={cn(styles.prev, scroll_pos<=0.05 && styles.hidden)}
                onClick={()=>{
                  scroll(width >= 768 ? 50 : 20, 'bw', '%');
                }}>
                <Icon_chevron_left/>
              </button>
              <button
                className={cn(styles.next, scroll_pos>=0.95 && styles.hidden)}
                onClick={()=>{
                  scroll(width >= 768 ? 50 : 20, 'fw', '%');
                }}>
                <Icon_chevron_right/>
              </button>
            </div>
            <div ref={categories_ref} className={styles.categories_wrapper}
              style={{cursor: is_dragging ? 'grabbing' : undefined}}>
              <div className={styles.categories_buttons} style={{
                pointerEvents: is_dragging ? 'none' : undefined,
              }}>
                <Link className={cn(styles.category_button, theme.p3,
                  theme.reg, !params.category &&
                  styles.category_button__active)}
                  to={`${root_url}/`}>All
                </Link>
                {safe_data_state.data.categories.map(cat=>{
                    const cat_cls = cn(styles.category_button, theme.p3,
                        cat.slug==params.category ?
                        styles.category_button__active : '');
                    const cat_img = cat.img ? <img src={cat.img}
                      alt={cat.name} width="24px" height="24px"/> : null;
                    return <Link key={cat.id} className={cat_cls}
                      to={`${root_url}/${cat.slug}`}>
                      {cat_img}{cat.name}
                    </Link>;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>}
      <div className={cn(theme.container, styles.container)}>
        {safe_data_state && safe_data_state.data ? <Fragment>
          <div className={styles.articles} ref={root_ref}
            key={params.category}>
            {safe_data_state.data.posts.map(v=>
                <Article_card key={v.id} {...v}/>)}
          </div>
        </Fragment> : <div>Loading...</div>}
        <Paging count={safe_data_state?.data?.total_pages} param="page"
          category={params.category} short={width<640}
          on_change={scroll_to_top}/>
        <Loader is_loading={is_loading} cls={styles.loader}/>
        <Spacer/>
        <Spacer/>
      </div>
    </div>;
};

export const Root = ()=>{
    const {params} = use_pathname();
    if (params?.slug)
      return <Article/>;
    return <Blog_root/>;
};
Root.meta = {
    ssr_force: true,
    nosearch: true,
    default_theme: 'toolip',
    meta: ({data_from_provider, params, translate})=>{
        translate = translate ? translate : t=>t;
        if (data_from_provider && data_from_provider[0] &&
            data_from_provider[0]?.data?.slug)
        {
          return Article.meta.meta({data_from_provider});
        }
        let canonical_url = 'https://toolip.io/blog';
        if (params.category)
            canonical_url += `/${params.category}`;
        if (params.page && params.page !== '1')
            canonical_url += `/page/${params.page}`;
        return {
            title: translate('Blog - Cheap Proxies IP Network'),
            description: translate('Uncover the advantages of blog - cheap '
                +'proxies ip network.'),
            canonical_url,
        };
    },
    is_dark_available: true,
    set_data_cache: (data_cache, params, data)=>{
        const cache_key = `/blog/page/${params.page}/category/`+
            `${params.category}/per_page/${params.per_page||9}`+
            `/slug/${params.slug}`;
        data_cache[cache_key] = data;
    },
    get_data_id,
    data_provider: (data_cache, params)=>etask(function*(){
        if (params.slug)
          return Article.meta.data_provider(data_cache, params);
        const cache_key = `/blog/page/${params.page}/category/`+
            `${params.category}/per_page/${params.per_page||9}/`+
            `slug/${params.slug}`;
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        let not_in = [];
        const end = `https://toolip.io/cms_api/blog/posts`;
        not_in = [];
        let data = yield fetch(`${end}?posts_per_page=${params.per_page||9}`+
            `&paged=${params.page||0}${params.category ?
            `&category=${params.category}` : ''}`+
            `${not_in.length>0 ? `&post__not_in=${not_in.join(',')}` : ''}`);
        if (typeof data!='object')
            data = {};
        data.posts = data.posts||[];
        data.categories = data.categories||[];
        const result = {
            data,
            error: '',
            cache_key,
            category: params.category,
        };
        data_cache[cache_key] = result;
        return result;
    }),
};
